import { SHOW_SUCCESS_NOTIFICATION, showNotification } from "Redux/Action";
import { Epic, ofType } from "redux-observable";
import { mergeMap } from "rxjs/operators";
import { of } from "rxjs";

export const showSuccessNotificationEpic: Epic = ( action$ ) => {
    return action$.pipe(
        ofType( SHOW_SUCCESS_NOTIFICATION ),
        mergeMap((action) => of(showNotification({ notificationType: 'success', message: action.payload.message })))
    )
}